export interface WithdrawViewData {
    channelList: any[],
    activeChannel: any,
    balanceAmount: number,
    selectedAmount: number | string,
    activeButton: boolean,
    uId: any,
    remainingTurnOver: number,
    withdrawControls: any[],
}

export interface WithdrawPopupData {
    show?: boolean,
    selectedChannel: Channel,
    activeTab: any,
    cpfID: string,
    emailID: string,
    phoneID: string,
    evpID: string,
    userName: string,
    cpfNumber: string,
    brazilID: string,
    bank: string,
    showCPFIdError: boolean,
    showEmaiIdError: boolean,
    showPhoneIdError: boolean,
    showEvpIdError: boolean,
    showCPFNumError: boolean,
    activeButton: boolean,
    selectedAmount: number,
    isDisabled: boolean,
}
export interface Channel {
    id: number | string;
    name: string;
    channelType: string;
    paymentType: number | string;
}

export interface NetworkChannelItem {
    channel: string;
    channelName: string;
    instructions: string;
}

export interface AddressChannelItem {
    address_label: string;
    address: string;
    chain_type: string;
}


export const TAB_TYPE_LIST = ([
    { id: 1, name: "CPF", errorText: "withdraw.cpfErrorText" },
    { id: 2, name: "E-mail", errorText: "withdraw.emailErrorText" },
    { id: 3, name: "PHONE", errorText: "withdraw.phoneErrorText" },
    { id: 4, name: "EVP", errorText: "withdraw.evpErrorText" },
])

export const TAB_ADDRESSBOOK = ([
    { id: 1, name: "withdraw.addressBook" },
    { id: 2, name: "withdraw.recently" },
])

export const TAB_SUB_ADDRESSBOOK = ([
    { id: 0, name: "withdraw.all" },
    { id: 1, name: "TRX" },
    { id: 2, name: "EHT" },
])
// --------------------

import { ref } from 'vue';
import { Html5Qrcode } from "html5-qrcode";
import { showToast } from 'vant';
import { getAddressBook, getNetworkOptions, withdraw, withdrawAddressOperations } from '@/api/withdraw';

export function useScanner() {
    const showScanner = ref(false);
    const scannedResult = ref('');
    let html5QrCode: Html5Qrcode | null = null;

    const startScanner = (elementId: string, onSuccess: (text: string) => void) => {
        showScanner.value = true;

        // Small delay to ensure the DOM element is rendered in the popup
        setTimeout(async () => {
            try {
                html5QrCode = new Html5Qrcode(elementId);
                const config = {
                    fps: 10,
                    qrbox: { width: 250, height: 250 }
                };

                await html5QrCode.start(
                    { facingMode: "environment" },
                    config,
                    (decodedText) => {
                        scannedResult.value = decodedText;
                        onSuccess(decodedText);
                        stopScanner();
                        showToast('Scanned Successfully');
                    },
                    undefined // errorMessageCallback
                );
            } catch (err) {
                console.error("Camera access failed", err);
                showToast('Camera access denied');
                showScanner.value = false;
            }
        }, 300);
    };

    const stopScanner = async () => {
        if (html5QrCode) {
            if (html5QrCode.isScanning) {
                await html5QrCode.stop();
            }

            html5QrCode.clear();
            html5QrCode = null;
        }
        showScanner.value = false;
    };

    return {
        showScanner,
        scannedResult,
        startScanner,
        stopScanner
    };
}


export const callAddressBook = async (filterType: any, networkType: any) => {
    const params: any = {
        filter_type: filterType,
        network_type: networkType
    }
    try {
        const res = await getAddressBook(params)
        return {
            addresses: res.data?.addresses || []
        }
    } catch (err) {
        console.error('Error fetching game list:', err)
        return { addresses: [] }
    }
}

export const callNetworkOptions = async (addr: string) => {
    const params: any = {
        address: addr,
    }
    try {
        const res = await getNetworkOptions(params)
        return {
            network_list: res.data || []
        }
    } catch (err) {
        console.error('Error fetching game list:', err)
        return { network_list: [] }
    }
}

export const addNewNetwork = async (address: string, addressLabel: string, channelId: any) => {
    const params: any = {
        addr: address,
        address_label: addressLabel,
        operation: "add",
        payment_channel_id: channelId
    }
    try {
        const res:any = await withdrawAddressOperations(params)
        return {
            data: res
        }
    } catch (err) {
        console.error('Error fetching game list:', err)
        return { data: err }
    }
}

export const deleteNetwork = async (address: string) => {
    const params: any = {
        addr: address,
        operation: "delete",
    }
    try {
        const res :any = await withdrawAddressOperations(params)
        return {
            data: res
        }
    } catch (err) {
        console.error('Error fetching game list:', err)
        return { data: err }
    }
}


export const callWithdraw = async (address: string, uid: any, amount: any, channelId: any, withdrawPassword: string) => {
    const params: any = {
        addr: address,
        uid: uid,
        amount: amount,
        payment_channel_id: channelId,
        withdraw_password: withdrawPassword
    }
    try {
        const res: any = await withdraw(params)
        return {
            data: res
        }
    } catch (err) {
        console.error('Error fetching game list:', err)
        return { data: err }
    }
}